import "styled-components";
import React, { useState, useEffect } from "react";
import moment from "moment";
import $ from "jquery";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";

export function ResultadosConsulta(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(props.datos);
  }, [props.datos]);

  $.fn.dataTable.ext.errMode = 'throw';
    $.fn.dataTable.moment("DD/MM/YYYY hh:mm A");
    $.fn.dataTable.moment("DD/MM/YYYY");
    
  $("#tbResultadoPadron").DataTable({
    language: LenguageTabla,
    pageLength: 10,
    processing: true,
    destroy: true,
    data: data,
    columns: [
      {
        data: null,
        render: function (row) {
          let tiposPersona =
            row.identificacionPrincipal.tipoPersona.descripcionCorta;
          row.identificacionesAsociadas.forEach(function (item) {
            tiposPersona +=
              "<br /><i>" + item.tipoPersona.descripcionCorta + "</i>";
          });
          return tiposPersona;
        },
      },
      {
        data: null,
        render: function (row) {
          let identificaciones = row.identificacionPrincipal.codigo;

          row.identificacionesAsociadas.forEach(function (item) {
            identificaciones += "<br /><i>" + item.codigo + "</i>";
          });
          return identificaciones;
        },
      },
      {
        data: "nombreCompleto",
      },
      {
        data: "fechaConstitucionONacimiento",
        render: function (row) {
          return row !== null ? moment(row).format("DD/MM/YYYY") : "";
        },
      },
      {
        data: null,
        render: function (row) {
          return row.paisRegistroONacimiento !== null
            ? row.paisRegistroONacimiento.nombrePais
            : "";
        },
      },
      {
        data: "descripcionGenero",
      },
      {
        data: "descripcionDefuncion",
      },
      {
        data: null,
        render: function (row) {
          return row.tieneAutorizacion ? "Sí" : "No";
        },
      },
    ],
    order: [[2, "asc"]],
  });

  return (
    <div className="card shadow mb-4">
      <div className="card-body">
        <table
          id="tbResultadoPadron"
          className="table table-striped table-hover display"
        >
          <thead>
            <tr>
              <th>Tipo Persona</th>
              <th>Identificación</th>
              <th>Nombre/Razón Social</th>
              <th>Fec.Nac/Fec.Con</th>
              <th>País.Nac/País.Reg</th>
              <th>Género</th>
              <th>Defunción</th>
              <th>Tiene Autorización</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
}
